module.exports = __webpack_public_path__ + "img/toon.0df76ffc.png";